import { getInstance } from "../../app";
import "./style.css";

export default class ContentPanel {
  static selector = ".content-panel";

  constructor(block) {
    this.block = block;

    this.closeButton = this.block.querySelector(".content-panel__close-button");

    this.panelWrapper = this.block.parentNode;

    this.wheel = document.querySelector(".mind-map");

    this.wheelItems = this.wheel.querySelectorAll(".ring-item");
    this.wheelFourthLevelItems = this.wheel.querySelectorAll(".text-group");

    this.spinner = this.block.querySelector(".content-panel__spinner");

    this.plusMargin = 12;

    this.openEvent = new Event("panelopen");
    this.closeEvent = new Event("panelclose");
  }

  handlePanelOpen = (navigateToUrl) => {
    document.querySelector(".mind-map").dispatchEvent(this.openEvent);
    window.App.navigateTo(navigateToUrl);
  };

  handlePanelClose = (navigateToUrl) => {
    window.removeEventListener("click", this.handleOutsideClick);
    this.panelWrapper.classList.remove("technologies__sidebar--open");
    document.body.classList.remove("no-scroll");

    this.spinner.classList.toggle("hidden");

    window.App.navigateTo(navigateToUrl, [".technologies__sidebar"], {
      event: this.closeEvent,
      eventTargetSelector: ".mind-map",
    });
  };

  handleCloseClick = (e) => {
    const url = this.closeButton.dataset.url;

    // remove hover state from items
    this.wheelItems.forEach((item) => item.classList.remove("highlight"));
    this.wheelFourthLevelItems.forEach((textGroup) => {
      const text = textGroup.querySelector("text");

      const plusIcon = textGroup.querySelector(".text-plus-icon");
      const rect = textGroup.querySelector("rect");

      const plusBBox = plusIcon.getBBox();
      const { width: plusWidth } = plusBBox;
      this.plusWidth = plusWidth;

      plusIcon.classList.remove("visible");
      rect.classList.remove("visible");
      text.classList.remove("active");

      if (textGroup.classList.contains("anchor-end")) {
        const g = text.parentNode;
        // items that go from 0° to 180°

        g.style.transform = `translateX(${this.plusWidth - this.plusMargin}px)`;
      }
    });

    this.handlePanelClose(url);
  };

  handleOutsideClick = (e) => {
    if (!this.block.contains(e.target)) {
      // clicked outside of panel
      this.handleCloseClick();
    }
  };

  onReady() {
    this.closeButton.addEventListener("click", this.handleCloseClick);

    if (this.panelWrapper.classList.contains("technologies__sidebar--open")) {
      // document.body.classList.add("no-scroll");
      window.addEventListener("click", this.handleOutsideClick);
    }
  }

  onResize() {}

  onDestroy() {
    this.closeButton.removeEventListener("click", this.handleCloseClick);
    window.removeEventListener("click", this.handleOutsideClick);
  }
}
